import React from "react";
import { LucideIcon } from "lucide-react";
import TicketInfoHeader from "./TicketInfoHeader";
import TicketInfoBody from "./TicketInfoBody";
import { TicketReceiver } from '../../../types/qztray/QzTrayTypes';

interface TicketInfoCardProps {
  /** Icono a mostrar (LucideIcon) */
  icon: LucideIcon;
  /** Título principal de la tarjeta */
  title: string;
  /** Subtítulo o descripción breve */
  subtitle?: string;

  /** Datos de la impresora o documento */
  printerName?: string;
  printerType?: string;
  createdAt?: string;
  referenceId?: string;
  receiver?: TicketReceiver | null;
  documentContext?: 'SALE' | 'PURCHASE';
}

/**
 * 🧾 TicketInfoCard
 *
 * Tarjeta completa que combina el encabezado (`TicketInfoHeader`)
 * y el cuerpo (`TicketInfoBody`) en un bloque visual cohesivo.
 *
 * Se usa para mostrar detalles del proceso de impresión (impresora,
 * metadatos del payload, referencia del documento, etc.).
 */
const TicketInfoCard: React.FC<TicketInfoCardProps> = ({
  icon,
  title,
  subtitle = "Información del dispositivo y documento",
  printerName,
  printerType,
  createdAt,
  referenceId,
  receiver,
  documentContext,
}) => {
  return (
    <div className="w-full overflow-hidden rounded-lg border border-stroke bg-white shadow-lg dark:border-strokedark  dark:bg-boxdark">
      {/* Encabezado */}
      <TicketInfoHeader icon={icon} title={title} subtitle={subtitle} />

      {/* Cuerpo */}
      <TicketInfoBody
        printerName={printerName}
        printerType={printerType}
        createdAt={createdAt}
        referenceId={referenceId}
        receiver={receiver}
        documentContext={documentContext}
      />
    </div>
  );
};

export default TicketInfoCard;
